import React from 'react';
import styled from 'styled-components';
import { Alert } from './StyledComponents';

const TabBar = styled.div`
  grid-column: 1 / -1;
  display: flex;
  gap: 0.5rem;
  border-bottom: 1px solid #333;
`;

const Tab = styled.button`
  background: ${(p) => (p.$active ? 'rgba(255, 215, 0, 0.08)' : 'transparent')};
  color: ${(p) => (p.$active ? '#ffd700' : '#888')};
  border: 1px solid ${(p) => (p.$active ? '#ffd700' : 'transparent')};
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  padding: 0.8rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover { color: #ffd700; }

  .sub {
    display: block;
    font-size: 0.72rem;
    font-weight: normal;
    color: #777;
    margin-top: 0.15rem;
  }
`;

// ---------------------------------------------------------------------------
// The Classic (native-PLS) system is legacy: its tab only appears for wallets
// that actually hold a Classic vault. Everyone else sees no tabs at all — just
// the vault. Copy stays plain: what each thing is, nothing more.
// ---------------------------------------------------------------------------

const EXPLAINERS = {
  easy: null, // the vault card explains itself — no banner needed
  classic: (
    <>
      <div className="title">Classic Vault</div>
      <div className="message">
        Your original native-PLS vault. Fully supported — manage, repay, or close it
        here any time.
      </div>
    </>
  )
};

const VaultModeTabs = ({ mode, onChange, showClassic }) => {
  if (!showClassic) return null; // one vault system → no tabs, no explainers
  return (
    <>
      <TabBar>
        <Tab $active={mode === 'easy'} onClick={() => onChange('easy')}>
          Vault
          <span className="sub">one transaction per action</span>
        </Tab>
        <Tab $active={mode === 'classic'} onClick={() => onChange('classic')}>
          Classic Vault
          <span className="sub">your original vault · native PLS</span>
        </Tab>
      </TabBar>
      {EXPLAINERS[mode] && (
        <div style={{ gridColumn: '1 / -1' }}>
          <Alert variant="info" style={{ marginBottom: 0 }}>{EXPLAINERS[mode]}</Alert>
        </div>
      )}
    </>
  );
};

export default VaultModeTabs;
